import { createAction } from 'redux-actions'

export const setClinicians = createAction('SET_CLINICIANS')
export const setCaregivers = createAction('SET_CAREGIVERS')
export const setFacilities = createAction('SET_FACILITIES')
export const setBillingCodes = createAction('SET_BILLINGS_CODES')
export const setCaseManagers = createAction('SET_CASE_MANAGERS')
export const setAgencyCaseManagers = createAction('SET_AGENCY_CASE_MANAGERS')

export const setActionCounter = createAction('SET_ACTION_COUNTER')
